import './_icon-link-list.scss';
import { replaceTimestamp } from '@/ts/utilities';

//Init function to replace timestamps in Icon Link LIst component

export default function IconLinkList() {
    replaceTimestamp();
}
